import React, { useState, useEffect, useRef } from 'react';
interface Country {
  code: string;
  name: string;
  dialCode: string;
  flag: string;
}
interface PhoneInputProps {
  codigoPais: string;
  numeroTelefono: string;
  onCodigoPaisChange: (codigo: string) => void;
  onNumeroTelefonoChange: (numero: string) => void;
  error?: string;
  disabled?: boolean;
  /** Altura y tipografía más compactas (p. ej. formularios embebidos). */
  compact?: boolean;
}
const countries: Country[] = [
  // América Latina
  { code: 'AR', name: 'Argentina', dialCode: '+54', flag: '🇦🇷' },
  { code: 'BR', name: 'Brasil', dialCode: '+55', flag: '🇧🇷' },
  { code: 'CL', name: 'Chile', dialCode: '+56', flag: '🇨🇱' },
  { code: 'CO', name: 'Colombia', dialCode: '+57', flag: '🇨🇴' },
  { code: 'MX', name: 'México', dialCode: '+52', flag: '🇲🇽' },
  { code: 'PE', name: 'Perú', dialCode: '+51', flag: '🇵🇪' },
  { code: 'UY', name: 'Uruguay', dialCode: '+598', flag: '🇺🇾' },
  { code: 'VE', name: 'Venezuela', dialCode: '+58', flag: '🇻🇪' },
  { code: 'BO', name: 'Bolivia', dialCode: '+591', flag: '🇧🇴' },
  { code: 'EC', name: 'Ecuador', dialCode: '+593', flag: '🇪🇨' },
  { code: 'PY', name: 'Paraguay', dialCode: '+595', flag: '🇵🇾' },
  { code: 'CR', name: 'Costa Rica', dialCode: '+506', flag: '🇨🇷' },
  { code: 'PA', name: 'Panamá', dialCode: '+507', flag: '🇵🇦' },
  { code: 'GT', name: 'Guatemala', dialCode: '+502', flag: '🇬🇹' },
  { code: 'HN', name: 'Honduras', dialCode: '+504', flag: '🇭🇳' },
  { code: 'SV', name: 'El Salvador', dialCode: '+503', flag: '🇸🇻' },
  { code: 'NI', name: 'Nicaragua', dialCode: '+505', flag: '🇳🇮' },
  { code: 'CU', name: 'Cuba', dialCode: '+53', flag: '🇨🇺' },
  { code: 'DO', name: 'República Dominicana', dialCode: '+1', flag: '🇩🇴' },
  { code: 'HT', name: 'Haití', dialCode: '+509', flag: '🇭🇹' },
  { code: 'JM', name: 'Jamaica', dialCode: '+1', flag: '🇯🇲' },
  { code: 'TT', name: 'Trinidad y Tobago', dialCode: '+1', flag: '🇹🇹' },
  // América del Norte
  { code: 'US', name: 'Estados Unidos', dialCode: '+1', flag: '🇺🇸' },
  { code: 'CA', name: 'Canadá', dialCode: '+1', flag: '🇨🇦' },
  // Europa
  { code: 'ES', name: 'España', dialCode: '+34', flag: '🇪🇸' },
  { code: 'IT', name: 'Italia', dialCode: '+39', flag: '🇮🇹' },
  { code: 'FR', name: 'Francia', dialCode: '+33', flag: '🇫🇷' },
  { code: 'DE', name: 'Alemania', dialCode: '+49', flag: '🇩🇪' },
  { code: 'GB', name: 'Reino Unido', dialCode: '+44', flag: '🇬🇧' },
  { code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹' },
  { code: 'NL', name: 'Países Bajos', dialCode: '+31', flag: '🇳🇱' },
  { code: 'BE', name: 'Bélgica', dialCode: '+32', flag: '🇧🇪' },
  { code: 'CH', name: 'Suiza', dialCode: '+41', flag: '🇨🇭' },
  { code: 'AT', name: 'Austria', dialCode: '+43', flag: '🇦🇹' },
  { code: 'SE', name: 'Suecia', dialCode: '+46', flag: '🇸🇪' },
  { code: 'NO', name: 'Noruega', dialCode: '+47', flag: '🇳🇴' },
  { code: 'DK', name: 'Dinamarca', dialCode: '+45', flag: '🇩🇰' },
  { code: 'FI', name: 'Finlandia', dialCode: '+358', flag: '🇫🇮' },
  { code: 'PL', name: 'Polonia', dialCode: '+48', flag: '🇵🇱' },
  { code: 'CZ', name: 'República Checa', dialCode: '+420', flag: '🇨🇿' },
  { code: 'HU', name: 'Hungría', dialCode: '+36', flag: '🇭🇺' },
  { code: 'RO', name: 'Rumania', dialCode: '+40', flag: '🇷🇴' },
  { code: 'BG', name: 'Bulgaria', dialCode: '+359', flag: '🇧🇬' },
  { code: 'GR', name: 'Grecia', dialCode: '+30', flag: '🇬🇷' },
  { code: 'RU', name: 'Rusia', dialCode: '+7', flag: '🇷🇺' },
  { code: 'UA', name: 'Ucrania', dialCode: '+380', flag: '🇺🇦' },
  { code: 'IE', name: 'Irlanda', dialCode: '+353', flag: '🇮🇪' },
  { code: 'IS', name: 'Islandia', dialCode: '+354', flag: '🇮🇸' },
  // Asia
  { code: 'CN', name: 'China', dialCode: '+86', flag: '🇨🇳' },
  { code: 'JP', name: 'Japón', dialCode: '+81', flag: '🇯🇵' },
  { code: 'KR', name: 'Corea del Sur', dialCode: '+82', flag: '🇰🇷' },
  { code: 'IN', name: 'India', dialCode: '+91', flag: '🇮🇳' },
  { code: 'TH', name: 'Tailandia', dialCode: '+66', flag: '🇹🇭' },
  { code: 'SG', name: 'Singapur', dialCode: '+65', flag: '🇸🇬' },
  { code: 'MY', name: 'Malasia', dialCode: '+60', flag: '🇲🇾' },
  { code: 'ID', name: 'Indonesia', dialCode: '+62', flag: '🇮🇩' },
  { code: 'PH', name: 'Filipinas', dialCode: '+63', flag: '🇵🇭' },
  { code: 'VN', name: 'Vietnam', dialCode: '+84', flag: '🇻🇳' },
  { code: 'TW', name: 'Taiwán', dialCode: '+886', flag: '🇹🇼' },
  { code: 'HK', name: 'Hong Kong', dialCode: '+852', flag: '🇭🇰' },
  { code: 'BD', name: 'Bangladesh', dialCode: '+880', flag: '🇧🇩' },
  { code: 'PK', name: 'Pakistán', dialCode: '+92', flag: '🇵🇰' },
  { code: 'LK', name: 'Sri Lanka', dialCode: '+94', flag: '🇱🇰' },
  { code: 'NP', name: 'Nepal', dialCode: '+977', flag: '🇳🇵' },
  { code: 'MM', name: 'Myanmar', dialCode: '+95', flag: '🇲🇲' },
  { code: 'KH', name: 'Camboya', dialCode: '+855', flag: '🇰🇭' },
  { code: 'LA', name: 'Laos', dialCode: '+856', flag: '🇱🇦' },
  { code: 'MN', name: 'Mongolia', dialCode: '+976', flag: '🇲🇳' },
  // Oceanía
  { code: 'AU', name: 'Australia', dialCode: '+61', flag: '🇦🇺' },
  { code: 'NZ', name: 'Nueva Zelanda', dialCode: '+64', flag: '🇳🇿' },
  { code: 'FJ', name: 'Fiyi', dialCode: '+679', flag: '🇫🇯' },
  { code: 'PG', name: 'Papúa Nueva Guinea', dialCode: '+675', flag: '🇵🇬' },
  { code: 'NC', name: 'Nueva Caledonia', dialCode: '+687', flag: '🇳🇨' },
  // África
  { code: 'ZA', name: 'Sudáfrica', dialCode: '+27', flag: '🇿🇦' },
  { code: 'EG', name: 'Egipto', dialCode: '+20', flag: '🇪🇬' },
  { code: 'NG', name: 'Nigeria', dialCode: '+234', flag: '🇳🇬' },
  { code: 'KE', name: 'Kenia', dialCode: '+254', flag: '🇰🇪' },
  { code: 'MA', name: 'Marruecos', dialCode: '+212', flag: '🇲🇦' },
  { code: 'TN', name: 'Túnez', dialCode: '+216', flag: '🇹🇳' },
  { code: 'DZ', name: 'Argelia', dialCode: '+213', flag: '🇩🇿' },
  { code: 'GH', name: 'Ghana', dialCode: '+233', flag: '🇬🇭' },
  { code: 'ET', name: 'Etiopía', dialCode: '+251', flag: '🇪🇹' },
  { code: 'UG', name: 'Uganda', dialCode: '+256', flag: '🇺🇬' },
  { code: 'TZ', name: 'Tanzania', dialCode: '+255', flag: '🇹🇿' },
  { code: 'ZW', name: 'Zimbabue', dialCode: '+263', flag: '🇿🇼' },
  { code: 'BW', name: 'Botsuana', dialCode: '+267', flag: '🇧🇼' },
  { code: 'NA', name: 'Namibia', dialCode: '+264', flag: '🇳🇦' },
  { code: 'ZM', name: 'Zambia', dialCode: '+260', flag: '🇿🇲' },
  { code: 'MW', name: 'Malaui', dialCode: '+265', flag: '🇲🇼' },
  { code: 'MZ', name: 'Mozambique', dialCode: '+258', flag: '🇲🇿' },
  { code: 'MG', name: 'Madagascar', dialCode: '+261', flag: '🇲🇬' },
  { code: 'MU', name: 'Mauricio', dialCode: '+230', flag: '🇲🇺' },
  { code: 'SC', name: 'Seychelles', dialCode: '+248', flag: '🇸🇨' },
  // Oriente Medio
  { code: 'SA', name: 'Arabia Saudí', dialCode: '+966', flag: '🇸🇦' },
  { code: 'AE', name: 'Emiratos Árabes Unidos', dialCode: '+971', flag: '🇦🇪' },
  { code: 'QA', name: 'Catar', dialCode: '+974', flag: '🇶🇦' },
  { code: 'KW', name: 'Kuwait', dialCode: '+965', flag: '🇰🇼' },
  { code: 'BH', name: 'Baréin', dialCode: '+973', flag: '🇧🇭' },
  { code: 'OM', name: 'Omán', dialCode: '+968', flag: '🇴🇲' },
  { code: 'JO', name: 'Jordania', dialCode: '+962', flag: '🇯🇴' },
  { code: 'LB', name: 'Líbano', dialCode: '+961', flag: '🇱🇧' },
  { code: 'SY', name: 'Siria', dialCode: '+963', flag: '🇸🇾' },
  { code: 'IQ', name: 'Irak', dialCode: '+964', flag: '🇮🇶' },
  { code: 'IR', name: 'Irán', dialCode: '+98', flag: '🇮🇷' },
  { code: 'IL', name: 'Israel', dialCode: '+972', flag: '🇮🇱' },
  { code: 'TR', name: 'Turquía', dialCode: '+90', flag: '🇹🇷' }
];

export function dialCodeForCountryCode(code: string): string {
  const c = countries.find((x) => x.code === code);
  return c ? c.dialCode : '+54';
}

/** Une prefijo internacional y número para persistencia (misma convención que el perfil). */
export function formatInternationalPhoneForStorage(codigoPais: string, numeroTelefono: string): string {
  const n = (numeroTelefono || '').trim();
  if (!n) return '';
  return `${dialCodeForCountryCode(codigoPais)} ${n}`.trim();
}

/** Invierte el formato guardado (`+54 911…`) a país ISO + solo dígitos locales. */
export function parseInternationalPhoneFromStorage(stored: string | null | undefined): {
  codigoPais: string;
  numeroTelefono: string;
} {
  const t = (stored || '').trim();
  if (!t) return { codigoPais: 'AR', numeroTelefono: '' };
  const spaceIdx = t.indexOf(' ');
  if (spaceIdx <= 0 || t[0] !== '+') {
    return { codigoPais: 'AR', numeroTelefono: t.replace(/\D/g, '') };
  }
  const dialPart = t.slice(0, spaceIdx).trim();
  const rest = t.slice(spaceIdx + 1).trim().replace(/\s/g, '');
  let bestLen = 0;
  let code = 'AR';
  for (const c of countries) {
    if (dialPart === c.dialCode && c.dialCode.length >= bestLen) {
      bestLen = c.dialCode.length;
      code = c.code;
    }
  }
  if (bestLen === 0) {
    for (const c of countries) {
      if (dialPart.startsWith(c.dialCode) && c.dialCode.length > bestLen) {
        bestLen = c.dialCode.length;
        code = c.code;
      }
    }
  }
  return { codigoPais: code, numeroTelefono: rest.replace(/\D/g, '') };
}

const PhoneInput: React.FC<PhoneInputProps> = ({
  codigoPais,
  numeroTelefono,
  onCodigoPaisChange,
  onNumeroTelefonoChange,
  error,
  disabled = false,
  compact = false,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCountries, setFilteredCountries] = useState(countries);
  const [isFocused, setIsFocused] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const searchInputRef = useRef<HTMLInputElement>(null);
  const phoneInputRef = useRef<HTMLInputElement>(null);
  const selectedCountry = countries.find(country => country.code === codigoPais) || countries[0];
  const validatePhoneNumber = (countryCode: string, phoneNumber: string): boolean => {
    if (!phoneNumber.trim()) return true; // Empty is valid (not required yet)
    const country = countries.find(c => c.code === countryCode);
    if (!country) return false;
    // Remove all non-digit characters
    const cleanNumber = phoneNumber.replace(/\D/g, '');
    // Comprehensive validation patterns for all countries
    const patterns: { [key: string]: RegExp } = {
      // América Latina
      'AR': /^\d{10,11}$/, // Argentina: 10-11 digits
      'BR': /^\d{10,11}$/, // Brasil: 10-11 digits
      'CL': /^\d{8,9}$/,   // Chile: 8-9 digits
      'CO': /^\d{10}$/,    // Colombia: 10 digits
      'MX': /^\d{10}$/,    // México: 10 digits
      'PE': /^\d{9}$/,     // Perú: 9 digits
      'UY': /^\d{8,9}$/,   // Uruguay: 8-9 digits
      'VE': /^\d{10,11}$/, // Venezuela: 10-11 digits
      'BO': /^\d{8}$/,     // Bolivia: 8 digits
      'EC': /^\d{9}$/,     // Ecuador: 9 digits
      'PY': /^\d{9}$/,     // Paraguay: 9 digits
      'CR': /^\d{8}$/,     // Costa Rica: 8 digits
      'PA': /^\d{8}$/,     // Panamá: 8 digits
      'GT': /^\d{8}$/,     // Guatemala: 8 digits
      'HN': /^\d{8}$/,     // Honduras: 8 digits
      'SV': /^\d{8}$/,     // El Salvador: 8 digits
      'NI': /^\d{8}$/,     // Nicaragua: 8 digits
      'CU': /^\d{8}$/,     // Cuba: 8 digits
      'DO': /^\d{10}$/,    // República Dominicana: 10 digits
      'HT': /^\d{8}$/,     // Haití: 8 digits
      'JM': /^\d{10}$/,    // Jamaica: 10 digits
      'TT': /^\d{10}$/,    // Trinidad y Tobago: 10 digits
      // América del Norte
      'US': /^\d{10}$/,    // Estados Unidos: 10 digits
      'CA': /^\d{10}$/,    // Canadá: 10 digits
      // Europa
      'ES': /^\d{9}$/,     // España: 9 digits
      'IT': /^\d{10,11}$/, // Italia: 10-11 digits
      'FR': /^\d{10}$/,    // Francia: 10 digits
      'DE': /^\d{10,11}$/, // Alemania: 10-11 digits
      'GB': /^\d{10,11}$/, // Reino Unido: 10-11 digits
      'PT': /^\d{9}$/,     // Portugal: 9 digits
      'NL': /^\d{9}$/,     // Países Bajos: 9 digits
      'BE': /^\d{9}$/,     // Bélgica: 9 digits
      'CH': /^\d{9}$/,     // Suiza: 9 digits
      'AT': /^\d{10,11}$/, // Austria: 10-11 digits
      'SE': /^\d{9}$/,     // Suecia: 9 digits
      'NO': /^\d{8}$/,     // Noruega: 8 digits
      'DK': /^\d{8}$/,     // Dinamarca: 8 digits
      'FI': /^\d{9,10}$/,  // Finlandia: 9-10 digits
      'PL': /^\d{9}$/,     // Polonia: 9 digits
      'CZ': /^\d{9}$/,     // República Checa: 9 digits
      'HU': /^\d{9}$/,     // Hungría: 9 digits
      'RO': /^\d{10}$/,    // Rumania: 10 digits
      'BG': /^\d{9}$/,     // Bulgaria: 9 digits
      'GR': /^\d{10}$/,    // Grecia: 10 digits
      'RU': /^\d{10,11}$/, // Rusia: 10-11 digits
      'UA': /^\d{9}$/,     // Ucrania: 9 digits
      'IE': /^\d{9}$/,     // Irlanda: 9 digits
      'IS': /^\d{7}$/,     // Islandia: 7 digits
      // Asia
      'CN': /^\d{11}$/,    // China: 11 digits
      'JP': /^\d{10,11}$/, // Japón: 10-11 digits
      'KR': /^\d{10,11}$/, // Corea del Sur: 10-11 digits
      'IN': /^\d{10}$/,    // India: 10 digits
      'TH': /^\d{9}$/,     // Tailandia: 9 digits
      'SG': /^\d{8}$/,     // Singapur: 8 digits
      'MY': /^\d{9,10}$/,  // Malasia: 9-10 digits
      'ID': /^\d{10,12}$/, // Indonesia: 10-12 digits
      'PH': /^\d{10}$/,    // Filipinas: 10 digits
      'VN': /^\d{9,10}$/,  // Vietnam: 9-10 digits
      'TW': /^\d{9}$/,     // Taiwán: 9 digits
      'HK': /^\d{8}$/,     // Hong Kong: 8 digits
      'BD': /^\d{10}$/,    // Bangladesh: 10 digits
      'PK': /^\d{10}$/,    // Pakistán: 10 digits
      'LK': /^\d{9}$/,     // Sri Lanka: 9 digits
      'NP': /^\d{10}$/,    // Nepal: 10 digits
      'MM': /^\d{9,10}$/,  // Myanmar: 9-10 digits
      'KH': /^\d{8,9}$/,   // Camboya: 8-9 digits
      'LA': /^\d{8,9}$/,   // Laos: 8-9 digits
      'MN': /^\d{8}$/,     // Mongolia: 8 digits
      // Oceanía
      'AU': /^\d{9,10}$/,  // Australia: 9-10 digits
      'NZ': /^\d{8,9}$/,   // Nueva Zelanda: 8-9 digits
      'FJ': /^\d{7,8}$/,   // Fiyi: 7-8 digits
      'PG': /^\d{8}$/,     // Papúa Nueva Guinea: 8 digits
      'NC': /^\d{6}$/,     // Nueva Caledonia: 6 digits
      // África
      'ZA': /^\d{9}$/,     // Sudáfrica: 9 digits
      'EG': /^\d{10}$/,    // Egipto: 10 digits
      'NG': /^\d{10,11}$/, // Nigeria: 10-11 digits
      'KE': /^\d{9,10}$/,  // Kenia: 9-10 digits
      'MA': /^\d{9}$/,     // Marruecos: 9 digits
      'TN': /^\d{8}$/,     // Túnez: 8 digits
      'DZ': /^\d{9}$/,     // Argelia: 9 digits
      'GH': /^\d{9}$/,     // Ghana: 9 digits
      'ET': /^\d{9}$/,     // Etiopía: 9 digits
      'UG': /^\d{9}$/,     // Uganda: 9 digits
      'TZ': /^\d{9}$/,     // Tanzania: 9 digits
      'ZW': /^\d{9}$/,     // Zimbabue: 9 digits
      'BW': /^\d{7,8}$/,   // Botsuana: 7-8 digits
      'NA': /^\d{9}$/,     // Namibia: 9 digits
      'ZM': /^\d{9}$/,     // Zambia: 9 digits
      'MW': /^\d{9}$/,     // Malaui: 9 digits
      'MZ': /^\d{9}$/,     // Mozambique: 9 digits
      'MG': /^\d{9}$/,     // Madagascar: 9 digits
      'MU': /^\d{7,8}$/,   // Mauricio: 7-8 digits
      'SC': /^\d{7}$/,     // Seychelles: 7 digits
      // Oriente Medio
      'SA': /^\d{9}$/,     // Arabia Saudí: 9 digits
      'AE': /^\d{9}$/,     // Emiratos Árabes Unidos: 9 digits
      'QA': /^\d{8}$/,     // Catar: 8 digits
      'KW': /^\d{8}$/,     // Kuwait: 8 digits
      'BH': /^\d{8}$/,     // Baréin: 8 digits
      'OM': /^\d{8}$/,     // Omán: 8 digits
      'JO': /^\d{9}$/,     // Jordania: 9 digits
      'LB': /^\d{8}$/,     // Líbano: 8 digits
      'SY': /^\d{9}$/,     // Siria: 9 digits
      'IQ': /^\d{10}$/,    // Irak: 10 digits
      'IR': /^\d{10}$/,    // Irán: 10 digits
      'IL': /^\d{9}$/,     // Israel: 9 digits
      'TR': /^\d{10}$/     // Turquía: 10 digits
    };
    const pattern = patterns[countryCode];
    return pattern ? pattern.test(cleanNumber) : cleanNumber.length >= 7 && cleanNumber.length <= 15;
  };
  useEffect(() => {
    const valid = validatePhoneNumber(codigoPais, numeroTelefono);
    setIsValid(valid);
  }, [codigoPais, numeroTelefono]);
  // Filtrar países basado en el término de búsqueda
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredCountries(countries);
    } else {
      const filtered = countries.filter(country =>
        country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        country.dialCode.includes(searchTerm) ||
        country.code.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredCountries(filtered);
    }
  }, [searchTerm]);
  // Enfocar el input de búsqueda cuando se abre el dropdown
  useEffect(() => {
    if (isDropdownOpen && searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }, [isDropdownOpen]);
  // Cerrar dropdown cuando se hace clic fuera
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);
  const handleCountrySelect = (country: Country) => {
    onCodigoPaisChange(country.code);
    setIsDropdownOpen(false);
    setSearchTerm('');
  };
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };
  const handleSearchKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape') {
      setIsDropdownOpen(false);
      setSearchTerm('');
    }
  };
  const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // Only allow digits, spaces, hyphens, and parentheses
    const cleanValue = value.replace(/[^\d\s\-()]/g, '');
    onNumeroTelefonoChange(cleanValue);
  };
  const pad = compact ? '6px 10px' : '10px 12px';
  const fs = compact ? '12px' : '13px';
  const countryMinW = compact ? '96px' : '120px';
  const countryGap = compact ? '6px' : '8px';
  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <div className="phone-input-container" style={{ 
        display: 'flex', 
        width: '100%', 
        border: error 
          ? '1px solid #ef4444' 
          : isFocused && !disabled
            ? '1px solid #CE2B15' 
            : '1px solid #e5e7eb', 
        borderRadius: '6px',
        boxShadow: error 
          ? '0 0 0 3px rgba(239, 68, 68, 0.1)' 
          : isFocused && !disabled
            ? '0 0 0 3px rgba(206, 43, 21, 0.1)' 
            : 'none',
        transition: 'all 0.3s ease',
        background: disabled ? '#f3f4f6' : '#ffffff'
      }}>
        {/* Selector de país */}
        <div style={{ position: 'relative', flexShrink: 0 }} ref={dropdownRef}>
          <button
            type="button"
            className="phone-input-country-button"
            onClick={() => {
              if (disabled) return;
              setIsDropdownOpen(!isDropdownOpen);
            }}
            disabled={disabled}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: countryGap,
              padding: pad,
              background: disabled ? '#f3f4f6' : '#f8fafc',
              border: 'none',
              borderRight: '1px solid #e5e7eb',
              cursor: disabled ? 'not-allowed' : 'pointer',
              fontFamily: 'Montserrat, sans-serif',
              fontSize: fs,
              color: disabled ? undefined : '#374151',
              minWidth: countryMinW,
            }}
          >
            <span>{selectedCountry.flag}</span>
            <span>{selectedCountry.dialCode}</span>
            <span>{isDropdownOpen ? '▲' : '▼'}</span>
          </button>
          {isDropdownOpen && !disabled && (
            <div
              className="phone-input-dropdown"
              style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                right: 0,
                background: '#ffffff',
                border: '1px solid #e5e7eb',
                borderTop: 'none',
                borderRadius: '0 0 6px 6px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                zIndex: 9999,
                maxHeight: '300px',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {/* Campo de búsqueda */}
              <div className="phone-input-search-container" style={{ padding: '8px', borderBottom: '1px solid #e5e7eb' }}>
                <input
                  ref={searchInputRef}
                  type="text"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  onKeyDown={handleSearchKeyDown}
                  placeholder="Buscar país..."
                  className="phone-input-search-field"
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid #e5e7eb',
                    borderRadius: '4px',
                    fontFamily: 'Montserrat, sans-serif',
                    fontSize: '13px',
                    color: '#374151',
                    outline: 'none'
                  }}
                />
              </div>
              {/* Lista de países */}
              <div style={{ maxHeight: '240px', overflow: 'auto' }}>
                {filteredCountries.length > 0 ? (
                  filteredCountries.map(country => (
                    <button
                      key={country.code}
                      type="button"
                      onClick={() => {
                        handleCountrySelect(country);
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        width: '100%',
                        padding: '8px 12px',
                        background: 'none',
                        border: 'none',
                        textAlign: 'left',
                        cursor: 'pointer',
                        fontFamily: 'Montserrat, sans-serif',
                        fontSize: '13px',
                        color: '#374151',
                        transition: 'background-color 0.2s'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#f1f5f9';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                      }}
                    >
                      <span>{country.flag}</span>
                      <span style={{ flex: 1 }}>{country.name}</span>
                      <span>{country.dialCode}</span>
                    </button>
                  ))
                ) : (
                  <div style={{
                    padding: '12px',
                    textAlign: 'center',
                    color: '#6b7280',
                    fontFamily: 'Montserrat, sans-serif',
                    fontSize: '13px'
                  }}>
                    No se encontraron países
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        {/* Campo de número de teléfono */}
        <div style={{ flex: 1 }}>
          <input
            ref={phoneInputRef}
            type="tel"
            value={numeroTelefono}
            onChange={handlePhoneNumberChange}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            placeholder="Número de teléfono"
            className="form-input phone-input-field"
            disabled={disabled}
            style={{
              width: '100%',
              border: 'none',
              borderRadius: 0,
              padding: pad,
              fontFamily: 'Montserrat, sans-serif',
              fontSize: fs,
              color: disabled ? undefined : '#374151',
              background: disabled ? '#f3f4f6' : 'transparent',
              outline: 'none',
              boxShadow: 'none',
              cursor: disabled ? 'not-allowed' : 'text',
            }}
          />
        </div>
      </div>
      {/* Mensajes de error */}
      {error && (
        <div style={{ color: '#dc2626', fontSize: '12px', marginTop: '4px', fontFamily: 'Montserrat, sans-serif' }}>{error}</div>
      )}
      {!isValid && numeroTelefono && (
        <div style={{ color: '#dc2626', fontSize: '12px', marginTop: '4px', fontFamily: 'Montserrat, sans-serif' }}>
          Número de teléfono inválido para {selectedCountry.name}
        </div>
      )}
    </div>
  );
};
export default PhoneInput;
